"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("./FormattedMessage"));

var _I18n = _interopRequireDefault(require("I18n"));

var defaultElements = {
  wrapper: 'span'
};

function createElement(elements, type) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return _react.default.createElement.apply(_react.default, [elements && elements[type] || defaultElements[type] || defaultElements.wrapper].concat(args));
}

var FormattedJSXMessage = function FormattedJSXMessage(props) {
  var fn = _I18n.default.lookup(props.message);

  if (fn === undefined || fn === null) {
    return _react.default.createElement("span", null, _I18n.default.missingTranslation(props.message, props.options));
  }

  var count = props.options && props.options.count;

  var countIsSet = _I18n.default.isSet(count);

  if ((0, _typeof2.default)(fn) === 'object' && countIsSet) {
    var pluralizer = _I18n.default.pluralization.get();

    var keys = pluralizer(count);

    while (keys.length) {
      var key = keys.shift();

      if (_I18n.default.isSet(fn[key])) {
        fn = fn[key];
        break;
      }
    }
  }

  var formattedProps = (0, _extends2.default)({}, props.options);

  if (countIsSet && typeof count === 'number') {
    formattedProps.count = _I18n.default.formatNumber(count);
  } else if (typeof fn === 'string') {
    console.warn("I18n: FormattedJSXMessage called with non-JSX message key " + props.message + ". See go/i18n-react for more info. ");
    return _react.default.createElement(_FormattedMessage.default, {
      message: props.message,
      options: props.options
    });
  }

  return fn(createElement, props.elements, formattedProps);
};

FormattedJSXMessage.propTypes = {
  message: _react.PropTypes.string.isRequired,
  elements: _react.PropTypes.object.isRequired,
  options: _react.PropTypes.object,
  jsxMessageValidator: function jsxMessageValidator(props, propName, componentName) {
    if (!props.message.endsWith('_jsx')) {
      console.warn("I18n: " + componentName + " called with invalid message prop not ending in _jsx for " + props.message);
    }
  }
};
var _default = FormattedJSXMessage;
exports.default = _default;
module.exports = exports.default;